module.exports = __webpack_public_path__ + "static/media/Stateview - NOP to Suspend.a4cd13d7.pdf";